// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.AppLayout_shell__713yO {
  display: flex;
  gap: 16px;
  padding: 16px;
  min-height: 100vh;
  background: var(--dylo-page-bg);
}

.AppLayout_main__Q7Na1 {
  flex: 1 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.AppLayout_content__TKzkQ {
  flex: 1 1;
  /* Permite que el contenedor se encoja por debajo del contenido: sin esto una página
     con algo de ancho fijo (un mapa, una tabla, la hoja de 860px de la pre-alerta)
     empuja todo el shell y las tarjetas salen cortadas. */
  min-width: 0;
  animation: AppLayout_dylo-fade-in__caiuJ 0.28s ease both;
}

/**
 * Header móvil: oculto en escritorio, donde el sidebar siempre se ve.
 *
 * \`--mobile-bar-h\` es el alto que **comparten el logo y el botón**. Va como variable y no
 * como dos valores sueltos porque el requisito es que midan lo mismo: con dos números
 * separados basta que alguien toque uno para que dejen de alinearse.
 */
.AppLayout_mobileBar__WrvrA {
  display: none;
  /**
   * 72px: **el mismo alto que \`.logoCard\` del sidebar** (ver \`Sidebar.module.css\`).
   *
   * No es un número elegido a ojo. Ahí el logotipo se ve bien porque llena la tarjeta, y
   * copiar la medida hace que el header y el menú desplegado se lean como la misma pieza en
   * lugar de dos tamaños parecidos pero distintos.
   */
  --mobile-bar-h: 72px;
}

/**
 * Logo en marco naranja.
 *
 * Ocupa **todo el ancho que sobra** (\`flex: 1\`) con el logotipo centrado, en lugar de ser una
 * píldora ajustada al contenido. Así el header se lee como una sola pieza —marco + botón— y no
 * como dos objetos sueltos separados por un hueco.
 *
 * \`min-width: 0\` porque es un elemento flexible: sin él no podría encogerse por debajo del
 * ancho del logotipo en pantallas muy angostas.
 */
.AppLayout_mobileLogo__DdWi1 {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: 1 1;
  min-width: 0;
  height: var(--mobile-bar-h);
  /* Mismo padding y radio que \`.logoCard\` del sidebar, para que sean la misma pieza. */
  padding: 10px 14px;
  box-sizing: border-box;
  border: 1.5px solid var(--dylo-orange);
  border-radius: 20px;
  background: var(--dylo-surface);
  /* Halo naranja muy tenue: enmarca sin competir con el logotipo. */
  box-shadow: 0 0 0 3px color-mix(in srgb, var(--dylo-orange) 12%, transparent);
}

/**
 * El logotipo **llena la tarjeta**, igual que en el sidebar.
 *
 * Antes tenía un alto fijo de 28px con tope porcentual y por eso se veía chico: el marco
 * creció y el logo se quedó igual. Con \`height: 100%\` + \`object-fit: contain\` el tamaño lo
 * manda el padding de la tarjeta, así que ajustar el alto del header ajusta el logo solo.
 */
.AppLayout_mobileLogoImg__syyvH {
  height: 100%;
  width: 100%;
  object-fit: contain;
  display: block;
}

/**
 * Botón de menú.
 *
 * Cuadrado y solo con el icono: la palabra "Menu" no aporta —la hamburguesa es universal— y
 * un objetivo cuadrado de 42px se acierta mejor con el pulgar que una píldora con texto.
 * 42px queda por encima del mínimo recomendado de 44px de alto útil contando el padding del
 * contenedor.
 */
.AppLayout_menuBtn__h-jUf {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  /* Cuadrado y del MISMO alto que el logo: comparten la variable del header. */
  width: var(--mobile-bar-h);
  height: var(--mobile-bar-h);
  flex-shrink: 0;
  box-sizing: border-box;
  border: var(--dylo-card-border-width) solid var(--dylo-surface-border);
  /* Mismo radio que la tarjeta del logo y que las del sidebar. */
  border-radius: 20px;
  background: var(--dylo-surface);
  box-shadow: var(--shadow-card);
  color: var(--dylo-ink);
  font-family: var(--font-sans);
  cursor: pointer;
  /* Solo opacidad y escala, según la convención del proyecto. */
  transition: opacity 0.15s ease, transform 0.15s ease;
}
/* Respuesta al toque: sin esto el botón se siente muerto en un teléfono, donde no hay hover. */
.AppLayout_menuBtn__h-jUf:active {
  opacity: 0.75;
  transform: scale(0.94);
}
.AppLayout_menuBtn__h-jUf:focus-visible {
  outline: 2px solid var(--dylo-orange);
  outline-offset: 2px;
}

/* La hamburguesa dibujada con bordes CSS se reemplazó por \`MenuIcon\` del catálogo: esta
   quedaba con esquinas cuadradas y un grosor distinto al del resto de los iconos. */

/* Fondo del drawer. Va por debajo del sidebar (z-index 120) y por encima de
   todo lo demás. */
.AppLayout_backdrop__yX6bs {
  position: fixed;
  inset: 0;
  z-index: 110;
  border: none;
  padding: 0;
  background: rgba(0, 0, 0, 0.55);
  cursor: pointer;
  animation: AppLayout_dylo-backdrop-in__DSQey 0.18s ease both;
}

@keyframes AppLayout_dylo-backdrop-in__DSQey {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

/**
 * MÓVIL.
 *
 * Antes esta consulta solo ponía \`.shell\` en columna, pero el sidebar seguía
 * midiendo 248px de ancho y casi toda la altura de la pantalla, así que quedaba
 * como un bloque angosto arriba y, al ser \`sticky\`, se deslizaba sobre el
 * contenido. El sidebar ahora es un drawer (ver \`Sidebar.module.css\`), así que
 * aquí ya no hace falta cambiar la dirección: el contenido ocupa todo el ancho
 * porque el sidebar salió del flujo.
 */
@media (max-width: 720px) {
  .AppLayout_shell__713yO {
    padding: 12px;
    gap: 12px;
  }
  /**
   * Header móvil: logo a la izquierda, hamburguesa a la derecha, **sticky**.
   *
   * El botón va a la derecha porque es donde llega el pulgar sin recolocar la mano, y porque
   * el drawer nace de ese mismo borde. Antes quedaba a la izquierda por herencia del sidebar
   * de escritorio.
   */
  .AppLayout_mobileBar__WrvrA {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 10px;

    position: sticky;
    top: 0;
    /**
     * Por debajo del drawer (120) y su fondo (110), por encima del contenido.
     *
     * Importa el orden: si el header quedara encima del fondo oscuro, seguiría iluminado
     * mientras el menú está abierto y parecería que no pertenece a la misma capa.
     */
    z-index: 100;

    /**
     * Se extiende **de borde a borde**.
     *
     * \`.shell\` tiene 12px de padding, así que un sticky en \`top: 0\` dejaría una franja por
     * la que el contenido asomaría al hacer scroll. Los márgenes negativos lo llevan hasta
     * el borde y el padding devuelve la separación interna.
     */
    margin: -12px -12px 0;
    padding: calc(12px + env(safe-area-inset-top, 0px)) 12px 10px;

    /**
     * Fondo de **cristal**: bastante transparente y con difuminado fuerte.
     *
     * Al 86% se veía casi opaco y el header parecía una barra pegada encima. Al 55% con
     * \`blur(18px)\` el contenido se insinúa detrás —se nota que hay una capa— sin que el texto
     * de abajo cruce el logo. Es el mismo tratamiento que el drawer, así que las dos
     * superficies flotantes se leen como el mismo material.
     */
    background: color-mix(in srgb, var(--dylo-page-bg) 55%, transparent);
    backdrop-filter: blur(18px);
    -webkit-backdrop-filter: blur(18px);
    border-bottom: 1px solid color-mix(in srgb, var(--dylo-line) 45%, transparent);
  }

  /**
   * Si el navegador no soporta \`backdrop-filter\`, el fondo se vuelve opaco.
   *
   * Sin esto el header quedaría semitransparente **sin** difuminado, que es el peor de los
   * dos mundos: se lee el contenido de atrás a través del logo.
   */
  @supports not ((backdrop-filter: blur(1px)) or (-webkit-backdrop-filter: blur(1px))) {
    .AppLayout_mobileBar__WrvrA {
      background: var(--dylo-page-bg);
    }
  }

  /**
   * Red de seguridad del shell: ninguna página debe poder generar scroll horizontal
   * de la ventana en un teléfono.
   *
   * 🔑 Se usa \`overflow-x: clip\` y **no** \`hidden\`. \`hidden\` crea un contenedor de scroll,
   * y eso **rompe \`position: sticky\`** en cualquier descendiente — hay páginas que lo usan.
   * \`clip\` recorta sin crear contexto de scroll, así que sticky sigue funcionando.
   *
   * Es una red, no la solución: cada página sigue siendo responsable de que su contenido
   * ancho scrollee dentro de su propia tarjeta.
   */
  .AppLayout_content__TKzkQ {
    overflow-x: clip;
  }
}

/* =====================================================================
   Módulo Developer: el shell también se viste
   =====================================================================

   🔑 La paleta ya llega sola: \`body.dylo-dev-shell\` declara los tokens y todo lo que use
   \`var(--dylo-*)\` cambia sin tocarse. Lo que hace falta aquí es lo que está escrito **a medida** en
   este archivo y por tanto no se puede cambiar con una variable.

   🔴 **El problema que resuelve:** el shell tiene 16px de relleno y su propio fondo, así que la
   sección quedaba enmarcada por una franja del fondo de siempre y —en pantalla grande, donde el
   contenido no llena el alto— con una banda vacía debajo. El módulo se leía como una tarjeta metida
   en la plataforma en lugar de ser la pantalla.

   📌 Se ataca con \`:global(body.dylo-dev-shell)\` porque las clases de este archivo las renombra CSS
   Modules al compilar: desde el archivo global del tema no se pueden nombrar, y desde aquí sí. */

body.dylo-dev-shell .AppLayout_shell__713yO {
  /*
    🔴 **Aquí estuvo el sidebar pegado al borde.** El primer intento puso \`padding: 0\` para quitar la
    sensación de tarjeta flotante, y se pasó: el menú quedaba sin un pixel de aire a la izquierda.
    Además \`.sidebar\` cuenta con ese relleno — su \`top: 16px\` y su \`height: calc(100vh - 32px)\` están
    escritos suponiéndolo.

    🔑 Lo que producía el efecto de tarjeta **no era el relleno**, era que el fondo de alrededor tenía
    otro color. Ahora que el \`<body>\` comparte la paleta, el relleno se lee como el aire del chasis y
    no como el borde de una tarjeta. Se conserva, un poco más ajustado que el original.
  */
  padding: 14px;
  gap: 14px;
  background: var(--matrix-bg);
}

/*
  El \`<div>\` de la sección tiene que **llenar el alto visible**, o el fondo, la rejilla y el barrido
  terminan a media pantalla y el resto se queda en el color de siempre. Era la banda vacía debajo del
  contenido en monitor grande.

  ⚠️ Se resuelve con la cadena de flex y **no** con \`min-height: 100vh\` en \`.main\`: con los 14px de
  relleno del shell, 100vh de alto mínimo se sale 28px y aparece una barra de desplazamiento que no
  debería estar. \`.shell\` ya mide 100vh y estira a \`.main\`; lo único que faltaba era que \`.content\`
  fuera contenedor flex para poder estirar a su hijo.
*/
body.dylo-dev-shell .AppLayout_main__Q7Na1 {
  gap: 14px;
}
body.dylo-dev-shell .AppLayout_content__TKzkQ {
  display: flex;
  flex-direction: column;
}
body.dylo-dev-shell .AppLayout_content__TKzkQ > * {
  flex: 1 0 auto;
}

/* El botón del menú móvil y la tarjeta del logotipo, rectos como todo lo demás. */
body.dylo-dev-shell .AppLayout_menuBtn__h-jUf,
body.dylo-dev-shell .AppLayout_mobileLogo__DdWi1 {
  border-radius: 0;
}
body.dylo-dev-shell .AppLayout_mobileBar__WrvrA {
  padding: 10px;
}
`, "",{"version":3,"sources":["webpack://./src/v2/layout/AppLayout.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,SAAS;EACT,aAAa;EACb,iBAAiB;EACjB,+BAA+B;AACjC;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,SAAO;EACP;;0DAEwD;EACxD,YAAY;EACZ,wDAAuC;AACzC;;AAEA;;;;;;EAME;AACF;EACE,aAAa;EACb;;;;;;IAME;EACF,oBAAoB;AACtB;;AAEA;;;;;;;;;EASE;AACF;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,SAAO;EACP,YAAY;EACZ,2BAA2B;EAC3B,qFAAqF;EACrF,kBAAkB;EAClB,sBAAsB;EACtB,sCAAsC;EACtC,mBAAmB;EACnB,+BAA+B;EAC/B,kEAAkE;EAClE,6EAA6E;AAC/E;;AAEA;;;;;;EAME;AACF;EACE,YAAY;EACZ,WAAW;EACX,mBAAmB;EACnB,cAAc;AAChB;;AAEA;;;;;;;EAOE;AACF;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,6EAA6E;EAC7E,0BAA0B;EAC1B,2BAA2B;EAC3B,cAAc;EACd,sBAAsB;EACtB,sEAAsE;EACtE,+DAA+D;EAC/D,mBAAmB;EACnB,+BAA+B;EAC/B,8BAA8B;EAC9B,sBAAsB;EACtB,6BAA6B;EAC7B,eAAe;EACf,8DAA8D;EAC9D,oDAAoD;AACtD;AACA,+FAA+F;AAC/F;EACE,aAAa;EACb,sBAAsB;AACxB;AACA;EACE,qCAAqC;EACrC,mBAAmB;AACrB;;AAEA;oFACoF;;AAEpF;mBACmB;AACnB;EACE,eAAe;EACf,QAAQ;EACR,YAAY;EACZ,YAAY;EACZ,UAAU;EACV,+BAA+B;EAC/B,eAAe;EACf,4DAA2C;AAC7C;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;;AAEA;;;;;;;;;EASE;AACF;EACE;IACE,aAAa;IACb,SAAS;EACX;EACA;;;;;;IAME;EACF;IACE,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,SAAS;;IAET,gBAAgB;IAChB,MAAM;IACN;;;;;MAKE;IACF,YAAY;;IAEZ;;;;;;MAME;IACF,qBAAqB;IACrB,6DAA6D;;IAE7D;;;;;;;MAOE;IACF,oEAAoE;IACpE,2BAA2B;IAC3B,mCAAmC;IACnC,8EAA8E;EAChF;;EAEA;;;;;IAKE;EACF;IACE;MACE,+BAA+B;IACjC;EACF;;EAEA;;;;;;;;;;IAUE;EACF;IACE,gBAAgB;EAClB;AACF;;AAEA;;;;;;;;;;;;;;iGAciG;;AAEjG;EACE;;;;;;;;;GASC;EACD,aAAa;EACb,SAAS;EACT,4BAA4B;AAC9B;;AAEA;;;;;;;;;CASC;AACD;EACE,SAAS;AACX;AACA;EACE,aAAa;EACb,sBAAsB;AACxB;AACA;EACE,cAAc;AAChB;;AAEA,kFAAkF;AAClF;;EAEE,gBAAgB;AAClB;AACA;EACE,aAAa;AACf","sourcesContent":[".shell {\n  display: flex;\n  gap: 16px;\n  padding: 16px;\n  min-height: 100vh;\n  background: var(--dylo-page-bg);\n}\n\n.main {\n  flex: 1;\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.content {\n  flex: 1;\n  /* Permite que el contenedor se encoja por debajo del contenido: sin esto una página\n     con algo de ancho fijo (un mapa, una tabla, la hoja de 860px de la pre-alerta)\n     empuja todo el shell y las tarjetas salen cortadas. */\n  min-width: 0;\n  animation: dylo-fade-in 0.28s ease both;\n}\n\n/**\n * Header móvil: oculto en escritorio, donde el sidebar siempre se ve.\n *\n * `--mobile-bar-h` es el alto que **comparten el logo y el botón**. Va como variable y no\n * como dos valores sueltos porque el requisito es que midan lo mismo: con dos números\n * separados basta que alguien toque uno para que dejen de alinearse.\n */\n.mobileBar {\n  display: none;\n  /**\n   * 72px: **el mismo alto que `.logoCard` del sidebar** (ver `Sidebar.module.css`).\n   *\n   * No es un número elegido a ojo. Ahí el logotipo se ve bien porque llena la tarjeta, y\n   * copiar la medida hace que el header y el menú desplegado se lean como la misma pieza en\n   * lugar de dos tamaños parecidos pero distintos.\n   */\n  --mobile-bar-h: 72px;\n}\n\n/**\n * Logo en marco naranja.\n *\n * Ocupa **todo el ancho que sobra** (`flex: 1`) con el logotipo centrado, en lugar de ser una\n * píldora ajustada al contenido. Así el header se lee como una sola pieza —marco + botón— y no\n * como dos objetos sueltos separados por un hueco.\n *\n * `min-width: 0` porque es un elemento flexible: sin él no podría encogerse por debajo del\n * ancho del logotipo en pantallas muy angostas.\n */\n.mobileLogo {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  flex: 1;\n  min-width: 0;\n  height: var(--mobile-bar-h);\n  /* Mismo padding y radio que `.logoCard` del sidebar, para que sean la misma pieza. */\n  padding: 10px 14px;\n  box-sizing: border-box;\n  border: 1.5px solid var(--dylo-orange);\n  border-radius: 20px;\n  background: var(--dylo-surface);\n  /* Halo naranja muy tenue: enmarca sin competir con el logotipo. */\n  box-shadow: 0 0 0 3px color-mix(in srgb, var(--dylo-orange) 12%, transparent);\n}\n\n/**\n * El logotipo **llena la tarjeta**, igual que en el sidebar.\n *\n * Antes tenía un alto fijo de 28px con tope porcentual y por eso se veía chico: el marco\n * creció y el logo se quedó igual. Con `height: 100%` + `object-fit: contain` el tamaño lo\n * manda el padding de la tarjeta, así que ajustar el alto del header ajusta el logo solo.\n */\n.mobileLogoImg {\n  height: 100%;\n  width: 100%;\n  object-fit: contain;\n  display: block;\n}\n\n/**\n * Botón de menú.\n *\n * Cuadrado y solo con el icono: la palabra \"Menu\" no aporta —la hamburguesa es universal— y\n * un objetivo cuadrado de 42px se acierta mejor con el pulgar que una píldora con texto.\n * 42px queda por encima del mínimo recomendado de 44px de alto útil contando el padding del\n * contenedor.\n */\n.menuBtn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  /* Cuadrado y del MISMO alto que el logo: comparten la variable del header. */\n  width: var(--mobile-bar-h);\n  height: var(--mobile-bar-h);\n  flex-shrink: 0;\n  box-sizing: border-box;\n  border: var(--dylo-card-border-width) solid var(--dylo-surface-border);\n  /* Mismo radio que la tarjeta del logo y que las del sidebar. */\n  border-radius: 20px;\n  background: var(--dylo-surface);\n  box-shadow: var(--shadow-card);\n  color: var(--dylo-ink);\n  font-family: var(--font-sans);\n  cursor: pointer;\n  /* Solo opacidad y escala, según la convención del proyecto. */\n  transition: opacity 0.15s ease, transform 0.15s ease;\n}\n/* Respuesta al toque: sin esto el botón se siente muerto en un teléfono, donde no hay hover. */\n.menuBtn:active {\n  opacity: 0.75;\n  transform: scale(0.94);\n}\n.menuBtn:focus-visible {\n  outline: 2px solid var(--dylo-orange);\n  outline-offset: 2px;\n}\n\n/* La hamburguesa dibujada con bordes CSS se reemplazó por `MenuIcon` del catálogo: esta\n   quedaba con esquinas cuadradas y un grosor distinto al del resto de los iconos. */\n\n/* Fondo del drawer. Va por debajo del sidebar (z-index 120) y por encima de\n   todo lo demás. */\n.backdrop {\n  position: fixed;\n  inset: 0;\n  z-index: 110;\n  border: none;\n  padding: 0;\n  background: rgba(0, 0, 0, 0.55);\n  cursor: pointer;\n  animation: dylo-backdrop-in 0.18s ease both;\n}\n\n@keyframes dylo-backdrop-in {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n\n/**\n * MÓVIL.\n *\n * Antes esta consulta solo ponía `.shell` en columna, pero el sidebar seguía\n * midiendo 248px de ancho y casi toda la altura de la pantalla, así que quedaba\n * como un bloque angosto arriba y, al ser `sticky`, se deslizaba sobre el\n * contenido. El sidebar ahora es un drawer (ver `Sidebar.module.css`), así que\n * aquí ya no hace falta cambiar la dirección: el contenido ocupa todo el ancho\n * porque el sidebar salió del flujo.\n */\n@media (max-width: 720px) {\n  .shell {\n    padding: 12px;\n    gap: 12px;\n  }\n  /**\n   * Header móvil: logo a la izquierda, hamburguesa a la derecha, **sticky**.\n   *\n   * El botón va a la derecha porque es donde llega el pulgar sin recolocar la mano, y porque\n   * el drawer nace de ese mismo borde. Antes quedaba a la izquierda por herencia del sidebar\n   * de escritorio.\n   */\n  .mobileBar {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 10px;\n\n    position: sticky;\n    top: 0;\n    /**\n     * Por debajo del drawer (120) y su fondo (110), por encima del contenido.\n     *\n     * Importa el orden: si el header quedara encima del fondo oscuro, seguiría iluminado\n     * mientras el menú está abierto y parecería que no pertenece a la misma capa.\n     */\n    z-index: 100;\n\n    /**\n     * Se extiende **de borde a borde**.\n     *\n     * `.shell` tiene 12px de padding, así que un sticky en `top: 0` dejaría una franja por\n     * la que el contenido asomaría al hacer scroll. Los márgenes negativos lo llevan hasta\n     * el borde y el padding devuelve la separación interna.\n     */\n    margin: -12px -12px 0;\n    padding: calc(12px + env(safe-area-inset-top, 0px)) 12px 10px;\n\n    /**\n     * Fondo de **cristal**: bastante transparente y con difuminado fuerte.\n     *\n     * Al 86% se veía casi opaco y el header parecía una barra pegada encima. Al 55% con\n     * `blur(18px)` el contenido se insinúa detrás —se nota que hay una capa— sin que el texto\n     * de abajo cruce el logo. Es el mismo tratamiento que el drawer, así que las dos\n     * superficies flotantes se leen como el mismo material.\n     */\n    background: color-mix(in srgb, var(--dylo-page-bg) 55%, transparent);\n    backdrop-filter: blur(18px);\n    -webkit-backdrop-filter: blur(18px);\n    border-bottom: 1px solid color-mix(in srgb, var(--dylo-line) 45%, transparent);\n  }\n\n  /**\n   * Si el navegador no soporta `backdrop-filter`, el fondo se vuelve opaco.\n   *\n   * Sin esto el header quedaría semitransparente **sin** difuminado, que es el peor de los\n   * dos mundos: se lee el contenido de atrás a través del logo.\n   */\n  @supports not ((backdrop-filter: blur(1px)) or (-webkit-backdrop-filter: blur(1px))) {\n    .mobileBar {\n      background: var(--dylo-page-bg);\n    }\n  }\n\n  /**\n   * Red de seguridad del shell: ninguna página debe poder generar scroll horizontal\n   * de la ventana en un teléfono.\n   *\n   * 🔑 Se usa `overflow-x: clip` y **no** `hidden`. `hidden` crea un contenedor de scroll,\n   * y eso **rompe `position: sticky`** en cualquier descendiente — hay páginas que lo usan.\n   * `clip` recorta sin crear contexto de scroll, así que sticky sigue funcionando.\n   *\n   * Es una red, no la solución: cada página sigue siendo responsable de que su contenido\n   * ancho scrollee dentro de su propia tarjeta.\n   */\n  .content {\n    overflow-x: clip;\n  }\n}\n\n/* =====================================================================\n   Módulo Developer: el shell también se viste\n   =====================================================================\n\n   🔑 La paleta ya llega sola: `body.dylo-dev-shell` declara los tokens y todo lo que use\n   `var(--dylo-*)` cambia sin tocarse. Lo que hace falta aquí es lo que está escrito **a medida** en\n   este archivo y por tanto no se puede cambiar con una variable.\n\n   🔴 **El problema que resuelve:** el shell tiene 16px de relleno y su propio fondo, así que la\n   sección quedaba enmarcada por una franja del fondo de siempre y —en pantalla grande, donde el\n   contenido no llena el alto— con una banda vacía debajo. El módulo se leía como una tarjeta metida\n   en la plataforma en lugar de ser la pantalla.\n\n   📌 Se ataca con `:global(body.dylo-dev-shell)` porque las clases de este archivo las renombra CSS\n   Modules al compilar: desde el archivo global del tema no se pueden nombrar, y desde aquí sí. */\n\n:global(body.dylo-dev-shell) .shell {\n  /*\n    🔴 **Aquí estuvo el sidebar pegado al borde.** El primer intento puso `padding: 0` para quitar la\n    sensación de tarjeta flotante, y se pasó: el menú quedaba sin un pixel de aire a la izquierda.\n    Además `.sidebar` cuenta con ese relleno — su `top: 16px` y su `height: calc(100vh - 32px)` están\n    escritos suponiéndolo.\n\n    🔑 Lo que producía el efecto de tarjeta **no era el relleno**, era que el fondo de alrededor tenía\n    otro color. Ahora que el `<body>` comparte la paleta, el relleno se lee como el aire del chasis y\n    no como el borde de una tarjeta. Se conserva, un poco más ajustado que el original.\n  */\n  padding: 14px;\n  gap: 14px;\n  background: var(--matrix-bg);\n}\n\n/*\n  El `<div>` de la sección tiene que **llenar el alto visible**, o el fondo, la rejilla y el barrido\n  terminan a media pantalla y el resto se queda en el color de siempre. Era la banda vacía debajo del\n  contenido en monitor grande.\n\n  ⚠️ Se resuelve con la cadena de flex y **no** con `min-height: 100vh` en `.main`: con los 14px de\n  relleno del shell, 100vh de alto mínimo se sale 28px y aparece una barra de desplazamiento que no\n  debería estar. `.shell` ya mide 100vh y estira a `.main`; lo único que faltaba era que `.content`\n  fuera contenedor flex para poder estirar a su hijo.\n*/\n:global(body.dylo-dev-shell) .main {\n  gap: 14px;\n}\n:global(body.dylo-dev-shell) .content {\n  display: flex;\n  flex-direction: column;\n}\n:global(body.dylo-dev-shell) .content > * {\n  flex: 1 0 auto;\n}\n\n/* El botón del menú móvil y la tarjeta del logotipo, rectos como todo lo demás. */\n:global(body.dylo-dev-shell) .menuBtn,\n:global(body.dylo-dev-shell) .mobileLogo {\n  border-radius: 0;\n}\n:global(body.dylo-dev-shell) .mobileBar {\n  padding: 10px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"shell": `AppLayout_shell__713yO`,
	"main": `AppLayout_main__Q7Na1`,
	"content": `AppLayout_content__TKzkQ`,
	"dylo-fade-in": `AppLayout_dylo-fade-in__caiuJ`,
	"mobileBar": `AppLayout_mobileBar__WrvrA`,
	"mobileLogo": `AppLayout_mobileLogo__DdWi1`,
	"mobileLogoImg": `AppLayout_mobileLogoImg__syyvH`,
	"menuBtn": `AppLayout_menuBtn__h-jUf`,
	"backdrop": `AppLayout_backdrop__yX6bs`,
	"dylo-backdrop-in": `AppLayout_dylo-backdrop-in__DSQey`
};
export default ___CSS_LOADER_EXPORT___;
